<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable fullscreen>
      <v-form ref="UploadStudentForm" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action }} Students</span>
            <v-spacer></v-spacer>
            <v-btn icon="mdi-close" variant="text" @click="closeD()"> </v-btn>
          </v-card-title>

          <v-card-text class="mt-4">
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  v-model="batch_selected"
                  @update:modelValue="showAddBatch"
                  :rules="[formRules.required]"
                  :items="batchList"
                  item-value="id"
                  :item-title="
                    (item) =>
                      item.year != ''
                        ? `${item.name}  (${item.year})`
                        : `${item.name}`
                  "
                  label="Please Select Batch"
                  variant="outlined"
                  density="compact"
                  class="rounded-lg"
                  :color="$vuetify.theme.themes.light.inputColor"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-file-input
                  @change="parseCSV()"
                  clearable
                  label="Upload Student List"
                  accept=".csv"
                  variant="outlined"
                  density="compact"
                  v-model="csv_file"
                ></v-file-input>
              </v-col>
            </v-row>

            <v-card class="my-5 dt-container" elevation="0" outlined>
              <div class="text-h4" v-if="!parsed && csv_file">Loading...</div>
              <v-data-table
                v-if="parsed && csv_file"
                :headers="headers"
                :items="csv_results.data"
                :loading="loading"
                hover
                density="compact"
                class="rounded-lg"
              >
                <template v-slot:[`item.bdate`]="{ item }">
                  {{ formatDate(item.bdate) }}
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="save()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Add
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <SkillAssessmentBatchDialog
      :data="batch_group"
      :action="'Add'"
      :batchToAdd="2"
    />
    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import Papa from "papaparse";
import SkillAssessmentBatchDialog from "./SkillAssessment/SkillAssessmentBatchDialog.vue";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      dialog: false,
      exceldata: [],
      program_id: null,
      email: null,
      address: null,
      batch_selected: null,
      batch: null,
      batch_year: null,
      batch_group: null,
      batchList: [],
      program_tied_id: null,
      btnLoading: false,
      loading: false,
      csv_results: [],
      csv_file: null,
      parsed: false,
      headers: [
        { title: "School Id", value: "school_id", align: "start" },
        { title: "First Name", value: "fname", align: "start" },
        { title: "Middle Name", value: "mname", align: "start" },
        { title: "Last Name", value: "lname", align: "start" },
        { title: "Suffix", value: "suffix", align: "start" },
        { title: "Sex", value: "sex", align: "start" },
        { title: "Email", value: "email", align: "start" },

        // {
        //   title: "Actions",
        //   value: "actions",
        //   align: "center",
        //   sortable: false,
        //   width: 200,
        // },
      ],
      programsList: [],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  components: {
    SkillAssessmentBatchDialog,
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log(data);
        this.initialize();
        this.$refs.UploadStudentForm.resetValidation();
      },
      deep: true,
    },
  },
  computed: {
    getProgramName() {
      let name = "";
      for (let i = 0; i < this.programsList.length; i++) {
        if (this.programsList[i].id == this.$store.state.user.program_id)
          name = this.programsList[i].name;
      }
      return name;
    },
  },

  mounted() {
    eventBus.on("closeSkillAssessmentBatchDialog", () => {
      console.log("vcalled me");
      this.getBatchList();
    });
  },
  beforeUnmount() {
    eventBus.off("closeSkillAssessmentBatchDialog");
  },
  methods: {
    initialize() {
      this.getBatchList();
      // this.getPrograms();
    },

    showAddBatch() {
      console.log("SLEE", this.batch_selected);
      if (this.batch_selected == -1) {
        this.batch_group = { id: null };
      }
    },

    parseCSV() {
      Papa.parse(this.csv_file, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          this.csv_results = results;
          this.parsed = true;
        }.bind(this),
      });
    },

    async save() {
      if (this.csv_results.data.length > 0) {
        this.btnLoading = true;
        let data = {
          batch_id: this.batch_selected,
          list: JSON.stringify(this.csv_results.data),
        };
        this.axiosCall("/student/bulk-create", "POST", data).then((res) => {
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    closeD() {
      eventBus.emit("closeUploadStudentDialog", true);
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },
    getBatchList() {
      this.batch_selected = null;
      this.axiosCall("/student/get-batch-list", "GET").then((res) => {
        this.batchList = res.data;
        this.batchList.push({ id: -1, name: "Add new Batch", year: "" });
      });
    },
  },
};
</script>
